import { get, post, put } from "./http.service";

const preserveHttpError = { preserveHttpError: true };

const BuildingService = {
  addBuilding: body => post(`property`, body, preserveHttpError),
  getBuildingById: id => get(`property/${id}`),
  getPropertyDimensions: id => get(`property/${id}/dimensions`),
  updateBuildingById: (id, body) => put(`property/${id}`, body, preserveHttpError),
  updateUnit: body => put(`property/unit`, body, preserveHttpError),
  previewBudSync: (id, body) => post(`property/${id}/bud-sync/preview`, body, preserveHttpError),
  applyBudSync: (id, body) => put(`property/${id}/bud-sync/apply`, body, preserveHttpError),
  updateAuditStatus: (id, body) => put(`property/updateAuditStatus/${id}`, body),
  updatePropertyWithBynderDATUrls: (id, body) => post(`bynder/${id}`, body),
};
export default BuildingService;
